/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class AggregateFilter {
    public static filter(): any {
        return (input: any, type: string): string => {
          if (!input)
            return type
          if (typeof(input) == "object") {
            // Check if there is only one object
            let propCount = 0
            let lastProp = type
            // Loop through properties
            for (var prop in input) {
                // Make sure that this is not inherited properties
                if (input.hasOwnProperty(prop)) {
                    if (input[prop]) {
                        propCount+=1
                        lastProp = prop
                    }
                }
            }
            if (propCount <= 1) {
                return lastProp
            }
            return "Multiple"
          }  
          else
            return input
        };
    }
}


angular.module('beneple.global')
    .filter('aggregate', AggregateFilter.filter);



// WEBPACK FOOTER //
// ./frontend/scripts/global/filters/aggregate.filter.ts